export default __webpack_public_path__ + "static/media/caret-down.5c6ad549.svg";